export default __webpack_public_path__ + "static/contact-hero-bc50689ca19712d1187e3c65f5d89fb9.jpg";